import { render } from "./CalcBox.vue?vue&type=template&id=af03cc54&scoped=true&bindings={\"isAuto\":\"options\",\"value\":\"options\",\"id\":\"props\",\"label\":\"props\",\"auto\":\"props\",\"values\":\"props\",\"parser\":\"props\",\"setAuto\":\"options\",\"setValue\":\"options\"}"
import script from "./CalcBox.vue?vue&type=script&lang=js"
export * from "./CalcBox.vue?vue&type=script&lang=js"

import "./CalcBox.vue?vue&type=style&index=0&id=af03cc54&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-af03cc54"

export default script